<zc-timeline-item [state]="state">
  <ng-content select="zc-step-title,zc-step-caption"></ng-content>

  <div *ngIf="state === 'active'">
    <ng-content></ng-content>
  </div>
</zc-timeline-item>
